import { createHoiPoiTheme } from '@Sage/hoi-poi-ui';

export let theme;
export const createTheme = (overTheme = {}) => {
    theme = createHoiPoiTheme(overTheme);
    return theme;
};
